/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import { Grid, CircularProgress, Box, Typography } from "@mui/material";
import { Stats } from "../mira/components/analytics/Stats";
import { Spacer } from "../utils/Spacer";
import { DashboardStatsItem } from "../../hooks/components/dashboard/useDashboardStats";

interface DashboardStatsProps {
  stats: DashboardStatsItem[];
  isLoading: boolean;
}

export const DashboardContactStats: React.FC<DashboardStatsProps> = ({
  stats,
  isLoading,
}) => {
  return (
    <>
      <Grid justifyContent="space-between" container spacing={6}>
        <Grid>
          <Typography variant="h4" gutterBottom>
            Contact Tickets
          </Typography>
        </Grid>
      </Grid>
      <Spacer />
      <Grid container spacing={6}>
        <Grid
          size={{
            xs: 12,
            lg: 12,
          }}
        >
          {isLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="200px"
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={6}>
              {stats.map((stat) => (
                <Grid
                  key={stat.title}
                  size={{
                    xs: 12,
                    sm: 12,
                    md: 2.4,
                  }}
                >
                  <Stats
                    title={stat.title}
                    amount={stat.amount}
                    percentageText={stat.percentageText}
                    percentageColor={stat.percentageColor}
                    clickPath={stat.navigationUrl}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};
